import React, { FC } from "react";
import { Box, Button } from "@mui/material";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

interface Props {
  handleSubmit: () => Promise<void>;
}

export const DistributionHandler: FC<Props> = ({ handleSubmit }) => {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  const onSubmit = async () => {
    try {
      await handleSubmit();
      goBack();
    } catch (err) {
      toast((err as Error).message);
    }
  };

  return (
    <Box className="flex justify-end gap-2 pb-2 mt-9">
      <Button
        variant="contained"
        onClick={goBack}
        className="!font-bold !capitalize !bg-surface-2 !text-text-1"
      >
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        className="!font-bold !capitalize"
      >
        Save
      </Button>
    </Box>
  );
};
